import * as _ from 'lodash';
import { AG_GRID_NUMBER_FILTER_TYPES } from './../ag-grid-filter.constant';
import { NumberFilterPassCases } from './number-filter-pass-cases.service';
import { NumberFilterUtils } from './number-filter-utils.service';

angular.module('nv.shared.services.sorter.agGrid').factory('NumberFilter', function() {
  let template = {
    singleFilterInput:
      '<div id="singleFilterInput">' +
      '<div>' +
      '<input class="ag-filter-filter" id="filterText" type="text" placeholder="Filter..."/>' +
      '</div>' +
      '</div>',
    rangeFilter:
      '<div id="multipleFilterInputs" style="display: none">' +
      '<div>' +
      '<input class="ag-filter-filter" id="filterTextRangeMin" type="text" placeholder="Min range..."/>' +
      '</div>' +
      '<div>' +
      '<input class="ag-filter-filter" id="filterTextRangeMax" type="text" placeholder="Max range..."/>' +
      '</div>' +
      '<div>',
    applyButton:
      '<div class="ag-filter-apply-panel" id="applyPanel">' +
      '<button type="button" id="applyButton">Apply Filter</button>' +
      '</div>',
    filtersSelect:
      '<div>' +
      '<select class="ag-filter-select" id="filterType">' +
      '<option value="1">Equals</option>' +
      '<option value="2">Not equal</option>' +
      '<option value="3">Less than</option>' +
      '<option value="4">Less than or equal</option>' +
      '<option value="5">Greater than</option>' +
      '<option value="6">Greater than or equal</option>' +
      '<option value="7">Range</option>' +
      '</select>' +
      '</div>',
    create() {
      return '<div>' + this.filtersSelect + this.singleFilterInput + this.rangeFilter + this.applyButton + '</div>';
    },
  };

  function NumberFilter() {
    //
  }

  NumberFilter.prototype.init = function(params) {
    this.filterParams = params.filterParams;
    this.applyActive = this.filterParams && this.filterParams.apply === true;
    // called when filter changes to inform grid to filter data
    this.filterChangedCallback = params.filterChangedCallback;
    // called when filter changes, but before 'Apply' is pressed. It calls gridOptions.filterModified();
    this.filterModifiedCallback = params.filterModifiedCallback;
    this.valueGetter = params.valueGetter; // called with a node as parameter to obtain value of that node
    this.createGui();

    this.filterNumber = null; // single input
    this.filterRangeMinNumber = null; // range input min
    this.filterRangeMaxNumber = null; // range input max
    this.filterType = AG_GRID_NUMBER_FILTER_TYPES.EQUALS; // default filter
    this.createApi();
  };

  NumberFilter.prototype.createGui = function() {
    this.eGui = NumberFilterUtils.loadTemplate(template.create());
    this.eTypeSelect = this.eGui.querySelector('#filterType');
    this.eFilterTextField = this.eGui.querySelector('#filterText');
    this.eFilterTextMinField = this.eGui.querySelector('#filterTextRangeMin');
    this.eFilterTextMaxField = this.eGui.querySelector('#filterTextRangeMax');

    // listener for type
    this.eTypeSelect.addEventListener('change', this.onTypeChanged.bind(this));
    // listeners for single input
    NumberFilterUtils.addChangeListener(this.eFilterTextField, this.onFilterChanged.bind(this));
    // listeners for minRange input
    NumberFilterUtils.addChangeListener(this.eFilterTextMinField, this.onFilterChanged.bind(this));
    // listeners for maxRange input
    NumberFilterUtils.addChangeListener(this.eFilterTextMaxField, this.onFilterChanged.bind(this));

    this.setupApplyButton();
  };

  NumberFilter.prototype.setupApplyButton = function() {
    let self = this;
    if (this.applyActive) {
      this.eApplyButton = this.eGui.querySelector('#applyButton');
      this.eApplyButton.addEventListener('click', function() {
        self.filterChangedCallback();
      });
    } else {
      NumberFilterUtils.removeElement(this.eGui, '#applyPanel');
    }
  };

  // Gets called when new rows are inserted into the grid
  NumberFilter.prototype.onNewRowsLoaded = function() {
    let keepSelection = this.filterParams && this.filterParams.newRowsAction === 'keep';
    if (!keepSelection) {
      this.api.setType(AG_GRID_NUMBER_FILTER_TYPES.EQUALS);
      this.api.setFilter(null);
    }
  };

  // Returns the GUI for filter
  NumberFilter.prototype.getGui = function() {
    return this.eGui;
  };

  // Gets called every time the popup is shown, after the gui returned in getGui is attached to the DOM
  NumberFilter.prototype.afterGuiAttached = function() {
    this.eFilterTextField.focus();
  };

  // This is used to show the filter icon in the header
  NumberFilter.prototype.isFilterActive = function() {
    if (this.isSetToRangeFilterType()) {
      return this.filterRangeMinNumber !== null && this.filterRangeMaxNumber !== null;
    } else {
      return this.filterNumber !== null;
    }
  };

  // The grid will ask each active filter (#isFilterActive) whether each row in the grid passes
  NumberFilter.prototype.doesFilterPass = function(node) {
    if (this.isSetToRangeFilterType()) {
      if (this.filterRangeMinNumber === null || this.filterRangeMaxNumber === null) {
        return true;
      }
    } else if (this.filterNumber === null) {
      return true;
    }

    const valueToFilterOn = NumberFilterUtils.standardizeValue(this.valueGetter(node));
    const filter = this.api.getFilter();

    if (!valueToFilterOn && valueToFilterOn !== 0) {
      return false;
    }

    // returns boolean
    return NumberFilterPassCases.evaluate(this.filterType, valueToFilterOn, filter);
  };

  NumberFilter.prototype.onTypeChanged = function() {
    this.filterType = parseInt(this.eTypeSelect.value);
    this.toggleInputs();
    this.filterChanged();
  };

  NumberFilter.prototype.filterChanged = function() {
    this.filterModifiedCallback();
    if (!this.applyActive) {
      this.filterChangedCallback();
    }
  };

  NumberFilter.prototype.onFilterChanged = function() {
    let newFilter;

    if (this.isSetToRangeFilterType()) {
      let filterTextMin = NumberFilterUtils.standardizeValue(this.eFilterTextMinField.value);
      let filterTextMax = NumberFilterUtils.standardizeValue(this.eFilterTextMaxField.value);

      newFilter = {
        min: filterTextMin,
        max: filterTextMax,
      };

      if (this.filterRangeMinNumber !== newFilter.min) {
        this.filterRangeMinNumber = newFilter.min;
        this.filterChanged();
      } else if (this.filterRangeMaxNumber !== newFilter.max) {
        this.filterRangeMaxNumber = newFilter.max;
        this.filterChanged();
      }
    } else {
      newFilter = NumberFilterUtils.standardizeValue(this.eFilterTextField.value);

      if (this.filterNumber !== newFilter) {
        this.filterNumber = newFilter;
        this.filterChanged();
      }
    }
  };

  NumberFilter.prototype.isSetToRangeFilterType = function() {
    return _.isEqual(this.filterType, AG_GRID_NUMBER_FILTER_TYPES.RANGE);
  };

  NumberFilter.prototype.toggleInputs = function() {
    const container = this.eGui;
    const singleFilterInput = container.querySelector('#singleFilterInput');
    const multipleFilterInputs = container.querySelector('#multipleFilterInputs');

    if (this.isSetToRangeFilterType()) {
      multipleFilterInputs.style.display = 'block';
      singleFilterInput.style.display = 'none';
    } else if (multipleFilterInputs.style.display === 'block') {
      multipleFilterInputs.style.display = 'none';
      singleFilterInput.style.display = 'block';
    }
  };

  NumberFilter.prototype.createApi = function() {
    let self = this;
    this.api = {
      EQUALS: AG_GRID_NUMBER_FILTER_TYPES.EQUALS,
      NOT_EQUAL: AG_GRID_NUMBER_FILTER_TYPES.NOT_EQUALS,
      LESS_THAN: AG_GRID_NUMBER_FILTER_TYPES.LESS_THAN,
      GREATER_THAN: AG_GRID_NUMBER_FILTER_TYPES.GREATER_THAN,
      LESS_THAN_OR_EQUAL: AG_GRID_NUMBER_FILTER_TYPES.LESS_THAN_OR_EQUAL,
      GREATER_THAN_OR_EQUAL: AG_GRID_NUMBER_FILTER_TYPES.GREATER_THAN_OR_EQUAL,
      RANGE: AG_GRID_NUMBER_FILTER_TYPES.RANGE,
      setType(type) {
        self.filterType = type;
        self.eTypeSelect.value = type;
      },
      setFilter(filter) {
        if (filter && self.isSetToRangeFilterType()) {
          self.eFilterTextMinField.value = self.filterRangeMinNumber = NumberFilterUtils.standardizeValue(filter.min);
          self.eFilterTextMaxField.value = self.filterRangeMaxNumber = NumberFilterUtils.standardizeValue(filter.max);
          self.toggleInputs(); // show range filter inputs
        } else {
          self.eFilterTextField.value = self.filterNumber = NumberFilterUtils.standardizeValue(filter);
        }
      },
      getType() {
        return self.filterType;
      },
      getFilter() {
        if (self.isSetToRangeFilterType()) {
          return {
            min: self.filterRangeMinNumber,
            max: self.filterRangeMaxNumber,
          };
        }
        return self.filterNumber;
      },
    };
  };

  NumberFilter.prototype.getModel = function() {
    let model = null;

    if (this.isFilterActive()) {
      model = {
        type: this.filterType,
        filter: this.api.getFilter(),
      };
    }
    return model;
  };

  NumberFilter.prototype.setModel = function(dataModel) {
    if (dataModel) {
      this.api.setType(dataModel.type);
      this.api.setFilter(dataModel.filter);
    } else {
      this.api.setFilter(null);
    }
  };

  NumberFilter.prototype.getApi = function() {
    return this.api;
  };

  return NumberFilter;
});
